<!--end::Header Logo-->
<div class="d-flex align-items-stretch me-3 menu-header">
    <div class="header-logo">
        <a href="javascript:void(0)" style="margin-left: 25px; margin-right: 25px">
            <!-- <img alt="Logo" src="../../../../../assets/media/logos/informate-logo-black-desktop.png" class="logo-default max-h-40px" /> -->
            <img alt="Logo" src="../../../../../../assets/media/logos/{{ IA }}" class="logo-sticky" style="height: 60px" />
        </a>
    </div>

    <ng-container *ngIf="headerMenuSelfDisplay" class="mobile_menu">
        <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
            <span></span>
        </button>
    </ng-container>

    <ng-container>
        <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            <ng-container>
                <app-management-organization-header
                    #ktHeaderMenu
                    id="kt_header_menu"
                    class="header-menu header-menu-left header-menu-mobile"
                    [ngClass]="headerMenuCSSClasses"
                >
                </app-management-organization-header>
            </ng-container>
        </div>
    </ng-container>
</div>
